import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import appearenceService from "./appearanceService";

const initialState = {
  seoStateLoading: false,
  seoStateSuccess: false,
  seoStateError: false,
  seo:"",
  seoStateErrorMsg: "",
};

// _______________________createFontSettings response function and services calling
export const createSeoSettings = createAsyncThunk(
  "createSeoSettings",
  async (data, thunkAPI) => {
    try {
      const response = await appearenceService.createSeoSettings(data);
      return response;
    } catch (error) {
      // handle all error like with status code  404 or 500 or 300 , not under 200
      const errorMsg =
        (error.response &&
          error.response.data &&
          error.response.data.errorMsg) ||
        error.errorMsg ||
        error.toString();
      return thunkAPI.rejectWithValue(errorMsg);
    }
  }
);

export const seoSettingsSlice = createSlice({
  name: 'seoSettings',
  initialState,
  reducers: {
    resetSeoSettings: (state) => {
      state.seoStateLoading = false;
      state.seoStateSuccess = false;
      state.seoStateError = false;
      state.seoStateErrorMsg = '';
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createSeoSettings.pending, (state) => {
        state.seoStateLoading = true;
      })
      .addCase(createSeoSettings.fulfilled, (state, action) => {
        state.seoStateLoading = false;
        state.seoStateSuccess = true;
        state.seo = action.payload;
      })
      .addCase(createSeoSettings.rejected, (state, action) => {
        state.seoStateLoading = false;
        state.seoStateError = true;
        state.seoStateErrorMsg = action.payload; // error from catch will come here via action.payload and update linkErrorMsg
      });
  },
});
export const { resetSeoSettings } = seoSettingsSlice.actions;
export default seoSettingsSlice.reducer;